module.exports = __webpack_public_path__ + "static/media/sheld_bg.d9026d2c.png";